import { Component } from "@angular/core";
import { SelectWindow, ModalService } from "@xo/client-common";
import { Type7Time, Type7TimeType } from "./Type7Time";

@Component({
    selector: "spec-app-type7-time-select",
    templateUrl: "./type7Time.select.html",
    styleUrls: ["./type7Time.select.scss"]
})
export class Type7TimeSelect extends SelectWindow<Type7Time> {

    constructor(modalService: ModalService) {
        super(modalService, Type7TimeType, "simpleField");
    }
}
